import styled from 'styled-components';
import { media } from 'designsystem/index';

const PhoneWrapper = styled.div`
  top: -1200px;
  position: absolute;
  margin-top: 250px;
  margin-left: -20px;
  width: 225px;
  transition: top 0.55s ease-in-out 0s;
  
  ${media.tablet`
    margin-left: -30px;
    margin-top: 200px;
    width: 265px;
  `};
  
   ${media.desktop`
    margin-left: auto;
    margin-right: auto;
    right: 42px;
    left: -60px;
    margin-top: 40px;
    width: 406px;
  `};
`;

export default PhoneWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/PhoneWrapper.jsx